<!--
 * @Description: 
 * @Author: xiaoq
 * @Date: 2024-06-13 16:04:03
 * @LastEditTime: 2024-09-14 11:22:36
 * @LastEditors: xiaoq
-->
<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
        <router-link to="/" class="nav-link1"> </router-link>
        <router-link to="/about" class="nav-link2"> </router-link>
        <router-link to="/question" class="nav-link3"> </router-link>
        <router-link to="/protocol" class="nav-link4"> </router-link>
        <router-link to="/protocol1" class="nav-link5"> </router-link>
        <router-link to="/protocol2" class="nav-link6"> </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/easylifetmdv/components/img/footer.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      altText: "图片",
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box {
  width: 100%;
  overflow: hidden;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6 {
  width: 100%;
  margin: auto;
}

.img1Box {
  position: relative;
  margin-top: -2px;
}
.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5,
.nav-link6 {
  /* border: 1px solid red; */
  position: absolute;
  cursor: pointer;
}

.nav-link1 {
  top: 6%;
  left: 44.6%;
  width: 6.3%;
  height: 6.3%;
}
.nav-link2 {
  top: 14%;
  left: 44.6%;
  width: 6%;
  height: 6.3%;
}
.nav-link3 {
  top: 22.2%;
  left: 44.6%;
  width: 15.3%;
  height: 6.3%;
}
.nav-link4 {
  top: 14.7%;
  width: 10.4%;
  left: 70%;
  height: 5%;
}
.nav-link5 {
  top: 21.7%;
  width: 11%;
  left: 70%;
  height: 5%;
}
.nav-link6 {
  top: 28.6%;
  width: 9.5%;
  left: 70%;
  height: 5%;
}
</style>
